<template lang="pug">
  .works
    SearchTags(
      :works="works"
      :results="results"
      :selected="selectedWork"
      tagHeight="2rem"
      @select="selectWork"
    )
    KeepAlive
      ResultsColumns(
        :results="displayResults"
        @select="expandResult"
        :key="'works-mobile'"
      )
</template>

<script>
import Works from './Works'
import ResultsColumns from '@/components/ResultsColumns'

export default {
  name: 'WorksMobile',

  extends: Works,

  components: {
    ResultsColumns
  },

  methods: {
    expandResult(result) {
      this.$router.push({
        name: 'result-full',
        params: {
          workId: result.workId,
          resultId: result.id
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '~@/settings';

.works {
  width: 100%;

  .search-tags {
    // padding: 0.5rem 0;
    // // small optical correction
    // padding-left: 0.46rem;

    &__content {
      padding: 0.5rem 0.46rem;
    }
  }

  .search-tag {
    margin-right: 0.4rem;
    box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
    border: none;
    color: map-get($color, medium);
  }

  .results-columns {
    padding: 0.5rem;
    padding-top: 0;
  }
}
</style>
